import inframarkLogo from "../../../../assets/Logo1.svg";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import UserContext from "common/Context/UserContext";
import { isPlatformAdminProfile } from "common/Utilities/Role.utils";
import { resetPlatformAdminCustomerSelection } from "common/Utilities/CustomerSelection.utils";
const BrandLogo = () => {
  const { userProfile } = useContext(UserContext);
  const profile = userProfile?.profile ?? {};
  const navigate = useNavigate();
  return (
    <div className="navbar-brand">
      <button
        className="brand-btn-without-bg"
        style={{ border: "none", background: "none" }}
        onClick={() => {
          resetPlatformAdminCustomerSelection();
          if (isPlatformAdminProfile(profile)) {
            window.location.assign("/");
            return;
          }
          navigate("/");
        }}
      >
        <img
          src={inframarkLogo}
          alt="Inframark Logo"
          style={{ paddingTop: "5px", paddingBottom: "5px", height:'65px' }}
        />
      </button>
    </div>
  );
};

export default BrandLogo;
